// extracted by mini-css-extract-plugin
export default {"root":"skkAkOvhmxKj1Q5DMFQM","icon":"pctr9heiCPT3qQ9p2oSt","disabled":"b8Hsy55KV2WZpzp0Q3oj"};